// Puedes colocar este componente en tu App.js o en el layout principal

import React from "react";
import { FaCoffee } from "react-icons/fa";

const FloatingDonateButton = () => (
  <a
    href="https://ko-fi.com/dub_dev"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      position: "fixed",
      left: "24px",
      bottom: "24px",
      background: "#29abe0",
      color: "#fff",
      padding: "12px 20px",
      borderRadius: "30px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      display: "flex",
      alignItems: "center",
      zIndex: 1000,
      textDecoration: "none",
      fontWeight: "bold",
      fontSize: "16px"
    }}
  >
    <FaCoffee style={{ marginRight: "8px" }} />
    Support Me on Ko-fi
  </a>
);

export default FloatingDonateButton;